import { styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{3,24}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

const roles = [
  {
    value: "FIRST",
    label: "Admin",
  },
  {
    value: "SECOND",
    label: "Customer",
  },
  {
    value: "THIRD",
    label: "Vendor",
  },
  {
    value: "FOURTH",
    label: "Delivery",
  },
];

const Input = styled("input")({
  display: "none",
});

const UserForm = () => {
  const [role, setRole] = useState("");

  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState("");
  const [isNameValid, setIsNameValid] = useState(false);
  const [userFocus, setUserFocus] = useState(false);

  const [password, setPassword] = useState("");
  const [isPwdValid, setIsPwdValid] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [confirmPwd, setConfirmPwd] = useState("");
  const [isconfirmPwdValid, setIsConfirmPwdValid] = useState(false);
  const [confirmPwdFocus, setConfirmPwdFocus] = useState(false);

  const [errorMessage, setErrMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    const result = USER_REGEX.test(user);
    console.log(result);
    console.log(user);
    setIsNameValid(result);
  }, [user]);

  useEffect(() => {
    const result = PWD_REGEX.test(password);
    console.log(result);
    console.log(password);
    setIsPwdValid(result);
    const isEqual = password === confirmPwd;
    setIsConfirmPwdValid(isEqual);
  }, [password, confirmPwd]);

  useEffect(() => {
    setErrMessage("");
  }, [user, password, confirmPwd]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const userResult = USER_REGEX.test(user);
    const passwordResult = PWD_REGEX.test(password);

    if (!userResult || !passwordResult) {
      return console.log("enter values");
    }
    console.log(user, password);
    const data = { user: user, password: password };

    axios({
      method: "POST",
      url: "https://6253f90789f28cf72b55b772.mockapi.io/Users",
      data: data,
    })
      .then((res) => {
        if (res.status === 201) {
          setIsSuccess(true);
        } else {
          alert(res.status);
        }
      })
      .catch((err) => console.log(err));
  };

  const [selectedImages, setSelectedImages] = useState([]);

  const onSelectedFile = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);

    const imagesArray = selectedFilesArray.map((file) => {
      return URL.createObjectURL(file);
    });

    setSelectedImages((previousImages) => previousImages.concat(imagesArray));
  };

  const handleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <Stack direction='column' spacing={2}>
      <TextField fullWidth label='Name' id='name' />
      <TextField fullWidth label='Email' id='email' />
      <TextField fullWidth label='Mobile Number' id='mobile_no' />
      <TextField fullWidth label='Password' id='password' />
      <TextField
        id='outlined-select-currency'
        select
        label='Select'
        value={role}
        onChange={handleChange}
        helperText='Please select your roles'
      >
        {roles.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <Box>
        <label htmlFor='upload-file'>
          <Button variant='contained' component='span'>
            Choose File
          </Button>{" "}
        </label>
        <Input
          accept='image/*'
          id='upload-file'
          multiple
          type='file'
          onChange={onSelectedFile}
        />
        <br />

        {selectedImages.length > 0 &&
          (selectedImages.length > 3 ? (
            <p>
              You can't upload more than 3 images! <br />
              <span>
                please delete <b>{selectedImages.length - 3}</b> of them
              </span>
            </p>
          ) : (
            <Button
              onClick={() => {
                console.log("UPLOAD IMAGES");
              }}
            >
              UPLOAD {selectedImages.length} IMAGE
              {selectedImages.length === 1 ? "" : "S"}
            </Button>
          ))}
        <Box>
          {selectedImages &&
            selectedImages.map((image, index) => {
              return (
                <div key={image}>
                  <img src={image} alt='' height='200' />
                  <Button
                    variant='contained'
                    color='error'
                    onClick={() =>
                      setSelectedImages(
                        selectedImages.filter((e) => e !== image)
                      )
                    }
                  >
                    Delete Image
                  </Button>
                </div>
              );
            })}
        </Box>
        {/* <Button variant='contained' component='span'>
          Choose File
        </Button> */}
      </Box>

      <Stack direction='row' spacing={2}>
        <Button variant='contained' disabled>
          SAVE
        </Button>
        <Button variant='contained' color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
};

export default UserForm;
